export default __webpack_public_path__ + "static/media/SEA_7387.8f68b950.jpg";